import { jsxs as l, jsx as a } from "react/jsx-runtime";
const n = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ a("g", { clipPath: "url(#hand-wave_svg__a)", children: /* @__PURE__ */ a(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M18.548 9.722a1.5 1.5 0 1 1 2.598 1.5l-4.25 7.362A6 6 0 0 1 8.7 20.78l-1.732-1 .18.104a6 6 0 0 1-2.99-4.844q-.011-.18-.02-.358-.046-.856.018-6.604A1.5 1.5 0 0 1 5.63 6.595a1.87 1.87 0 0 1 1.835 1.383l.538 2.008 3.75-6.496a1.5 1.5 0 0 1 2.598 1.5m0 0 1-1.731a1.5 1.5 0 1 1 2.598 1.5l-4.25 7.36m.652-7.128-2.97 4.995M16.95 6.49a1.5 1.5 0 0 1 2.598 1.5l-3.25 5.63"
        }
      ) }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "hand-wave_svg__a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
);
export {
  n as default
};
